<template>
  <div class="fee-summary-container animated fadeInRight">
    <el-row>
      <el-col :span="24">
        <!-- ========== 查询条件卡片  create by cht at 2026/6/16 10:50 ========== -->
        <el-card class="search-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('feeSummary.search.title') }}</span>
          </div>
          <el-form :model="searchForm" class="search-form">
            <el-row :gutter="10">
              <el-col :span="4">
                <el-input v-model="searchForm.roomName"
                          :placeholder="$t('feeSummary.search.roomNamePlaceholder')"></el-input>
              </el-col>
              <el-col :span="7">
                <el-date-picker v-model="searchForm.startDate" type="date" style="width: 48%;"
                              :placeholder="$t('feeSummary.search.startDatePlaceholder')"
                              value-format="yyyy-MM-dd"></el-date-picker>
                <span style="display: inline-block; width: 4%; text-align: center; line-height: 32px;">-</span>
                <el-date-picker v-model="searchForm.endDate" type="date" style="width: 48%;"
                              :placeholder="$t('feeSummary.search.endDatePlaceholder')"
                              value-format="yyyy-MM-dd"></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-input v-model="searchForm.configId"
                          :placeholder="$t('feeSummary.search.configIdPlaceholder')"></el-input>
              </el-col>
              <el-col :span="4">
                <el-input v-model="searchForm.feeName"
                          :placeholder="$t('feeSummary.search.feeNamePlaceholder')"></el-input>
              </el-col>
              <el-col :span="5">
                <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button @click="handleReset">{{ $t('common.reset') }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <!--   create by cht at 2026/6/16 10:50     -->
        <el-card>
          <div slot="header" class="clearfix">
            <span>{{ $t('feeSummary.title') }}</span>
            <div class="card-header-right">
              <!-- 新增导出按钮 create by cht at 2026/6/22 16:50 -->
              <el-button type="primary" size="small" @click="exportFeeSummary">
                <i class="el-icon-download"></i>
                {{ $t('common.export') }}
              </el-button>
            </div>
          </div>

          <el-table :data="feeSummaryInfo.fees" border style="width: 100%" v-loading="loading">
            <el-table-column prop="createTime" :label="$t('feeSummary.time')" align="center" />
            <el-table-column prop="roomName" :label="$t('feeSummary.roomName')" align="center" />
            <el-table-column prop="configId" :label="$t('feeSummary.feeItemId')" align="center" />
            <el-table-column prop="feeName" :label="$t('feeSummary.feeItemName')" align="center" />
            <el-table-column prop="startTime" :label="$t('feeSummary.startTime')" align="center" />    <!-- // create by cht at 2026/7/1 16:15 -->
            <el-table-column prop="endTime" :label="$t('feeSummary.endTime')" align="center" />        <!-- // create by cht at 2026/7/1 16:15 -->
            <el-table-column prop="receivableAmounts" :label="$t('feeSummary.receivableAmount')" align="center">
              <template slot-scope="scope">
                {{ scope.row.receivableAmounts }} {{ $t('feeSummary.yuan') }}
              </template>
            </el-table-column>
            <el-table-column prop="receivedAmounts" :label="$t('feeSummary.receivedAmount')" align="center">
              <template slot-scope="scope">
                {{ scope.row.receivedAmounts }} {{ $t('feeSummary.yuan') }}
              </template>
            </el-table-column>
          </el-table>

          <el-pagination class="pagination-wrapper" :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size" :total="page.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />

          <!-- ========== 新增：应收、实收小计区域  create by cht at 2026/6/11 15:10 ========== -->
          <div class="summary-wrapper">
            <div class="summary-item">
              <span class="summary-title">{{ $t('feeSummary.subtotal') }}：</span>
              <div class="summary-content">
                {{ $t('feeSummary.receivableAmount') }}：{{ feeSummaryInfo.allReceivableAmount }} {{ $t('feeSummary.yuan') }}
              </div>
              <div class="summary-content">
                {{ $t('feeSummary.receivedAmount') }}：{{ feeSummaryInfo.allReceivedAmount }} {{ $t('feeSummary.yuan') }}
              </div>
            </div>
          </div>

        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//新增exportData导出模块 create by cht at 2026/6/22 16:55
import { listFeeSummarys,exportData } from '@/api/fee/feeSummaryApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'FeeSummaryList',
  data() {
    return {
      loading: false,
      feeSummaryInfo: {
        fees: [],
        feeSummaryType: '1001',
        total: 0,
        allReceivableAmount: 0,  //新增总计应收金额和实收金额 create by cht at 2026/6/16 16:10
        allReceivedAmount: 0
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      communityId: '',
      // 新增：查询表单  create by cht at 2026/6/16 10:55
      searchForm: {
        roomName: '',
        startDate: '',  // 默认今天就改为new Date().toISOString().slice(0, 10)
        endDate: '',
        feeName: '',
        configId: ''
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._listFeeSummarys(this.page.current, this.page.size)
  },
  methods: {
    async _listFeeSummarys(page, size) {
      try {
        this.loading = true
        const params = {
          page,
          row: size,
          // feeSummaryType: this.feeSummaryInfo.feeSummaryType,   delete by cht at 2026/6/16 15:00
          communityId: this.communityId,
          // 新增3个查询参数 create by cht at 2026/6/16 10:55
          roomName: this.searchForm.roomName,
          feeName: this.searchForm.feeName,
          configId: this.searchForm.configId
        }
        // 时间查询参数 —— 时间范围处理(开始时间-结束时间)  create by cht at 2026/6/16 10:55
        if (this.searchForm.startDate) {
          params.startDate = this.searchForm.startDate
        }
        if (this.searchForm.endDate) {
          params.endDate = this.searchForm.endDate
        }

        const { fees, total , allReceivableAmount, allReceivedAmount} = await listFeeSummarys(params)   //新增接收allReceivableAmount, allReceivedAmount字段  create by cht at 2026/6/16 16:10
        this.feeSummaryInfo.fees = fees
        this.page.total = total
        this.feeSummaryInfo.allReceivableAmount = allReceivableAmount || 0   //create by cht at 2026/6/16 16:10
        this.feeSummaryInfo.allReceivedAmount = allReceivedAmount || 0       //create by cht at 2026/6/16 16:10
      } catch (error) {
        this.$message.error(this.$t('feeSummary.fetchError'))
      } finally {
        this.loading = false
      }
    },
    /*=============== create by cht at 2026/6/22 16:50 ===============*/
    async exportFeeSummary() {
      try {
        const params = {
          pagePath: 'reportFeeSummaryDetail',  // 对应后端的 Bean 名称
          communityId: this.communityId,
          roomName: this.searchForm.roomName,
          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate,
          configId: this.searchForm.configId,
          feeName: this.searchForm.feeName,
        }

        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error(this.$t('common.exportFailed'))
      }
    },
    /*=============== create by cht at 2026/6/22 16:50 ===============*/
    _switchFeeSummaryType(feeSummaryType) {
      this.feeSummaryInfo.feeSummaryType = feeSummaryType
      this.page.current = 1
      this._listFeeSummarys(this.page.current, this.page.size)
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listFeeSummarys(this.page.current, this.page.size)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listFeeSummarys(this.page.current, this.page.size)
    },

    // 新增-查询方法 create by cht at 2026/6/16 10:55
    handleSearch() {
      this.page.current = 1
      this._listFeeSummarys(this.page.current, this.page.size)
    },

    // 新增-重置方法 create by cht at 2026/6/16 10:55
    handleReset() {
      this.searchForm = {
        roomName: '',
        startDate: '',
        endDate: '',
        feeName: '',
        configId: ''
      }
      this.handleSearch()
    }

  }
}
</script>

<style lang="scss" scoped>
.fee-summary-container {
  padding: 20px;

  .clearfix {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .card-header-right {
    display: flex;
    align-items: center;
  }

  .pagination-wrapper {
    margin-top: 20px;
    text-align: right;
  }

  .el-button-group {
    margin-left: 10px;
  }

  /* 新增小计样式 create by cht at 2026/6/11 15:10 */
  .search-card {
    margin-bottom: 20px;
  }

  .list-card {
    .pagination-wrapper {
      margin-top: 20px;
      text-align: right;
    }
  }

  .summary-wrapper {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  .summary-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .summary-title {
    font-weight: bold;
    margin-right: 20px;
  }
  .summary-content {
    margin-right: 30px;
    margin-bottom: 10px;
  }

}
</style>
